<template>
	<right-panel :datas="connects" ref="rightPanel" @onClose="onClose" :hideFooter="true">
		<div slot="header">
			<translate>Check</translate>
		</div>

		<div slot="content" class="check">
			<!-- <div class="loading" v-if="loading">
				<img src="../../../assets/loading.gif" />
			</div> -->
			<div class="b-b b-t"><translate>Connection Information</translate></div>
			<div class="vertify-content">
				<el-row>
					<el-col :span="8" class="text-right"><translate>Name</translate><span>:</span></el-col>
					<el-col :span="13">{{ connects.name || '-' }}</el-col>
					<el-col :span="3" v-clipboard:copy="connects.name" v-clipboard:success="copySuccess">
						<a><translate>Copy</translate></a>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Type</translate><span>:</span></el-col>
					<el-col :span="13">{{ connects.type || '-' }}</el-col>
					<el-col :span="3" v-clipboard:copy="connects.type" v-clipboard:success="copySuccess">
						<a><translate>Copy</translate></a>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Address</translate><span>:</span></el-col>
					<el-col :span="13">{{ connects.ip || '-' }}</el-col>
					<el-col :span="3" v-clipboard:copy="connects.ip" v-clipboard:success="copySuccess">
						<a><translate>Copy</translate></a>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Port</translate><span>:</span></el-col>
					<el-col :span="13"> {{ connects.port || '-' }} </el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Code</translate><span>:</span></el-col>
					<el-col :span="13">{{ hideStr(contact.code )|| '-' }}</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Username</translate><span>:</span></el-col>
					<el-col :span="13">{{ connects.login_user ? connects.login_user[0] : '-' }}</el-col>
				</el-row>
				<!-- <el-row>
					<el-col :span="8" class="text-right"><translate>Password</translate><span>:</span></el-col>
					<el-col :span="10"><el-input v-model="connectInfo.password" :type="showPassword ? 'text' : 'password'"></el-input></el-col>
					<el-col :span="3">
						<i v-if="showPassword" @click="showPassword = false" class="material-icons">visibility_off</i>
						<i v-else @click="showPassword = true" class="material-icons">visibility</i>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="8" class="text-right"><translate>Report Type</translate><span>:</span></el-col>
					<el-col :span="10">
						<el-select v-model="connectInfo.type">
							<el-option v-for="(item, index) in reportTypeList" :label="item.name" :value="item.id" :key="index"> </el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row>
					<el-col :offset="8" :span="16">
						<div class="tips" v-if="o.os == 'mysql'">
							<translate tag="h4" class="text-center">Diagnostic connection users must have the following rights</translate>
							<translate tag="h4" class="text-center">grant select on information_schema.* to 'select'@'%';</translate>
							<translate tag="h4" class="text-center">grant process on *.* to 'select'@'%';</translate>
						</div>

						<div class="tips" v-if="o.os == 'mssql'">
							<translate tag="h4" class="text-center">A diagnostic connection user must have at least one of the following role permissions for the diagnostic database</translate>
							<translate tag="h4" class="text-center">- db_owner</translate>
							<translate tag="h4" class="text-center">- sysadmin</translate>
						</div>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="10" :offset="8">
						<el-button class="w-full m-t" v-if="!btnLoading" @click.stop="sendCheck" :disabled="!connectInfo.type">发起诊断</el-button>
						<el-button class="w-full m-t" v-if="btnLoading" :loading="btnLoading" disabled></el-button>
					</el-col>
				</el-row>
			</div>
			<div class="b-t m-t"><translate>Diagnostic Report List</translate></div>
			<el-table :data="m" style="width: 100%" v-loading="tableLoading">
				<el-table-column :label="attrText.reportname">
					<template scope="scope">{{ scope.row.name || '-' }} </template>
				</el-table-column>
				<el-table-column :label="attrText.hostname" width="130">
					<template scope="scope">{{ connects.name }} </template>
				</el-table-column>
				<el-table-column :label="attrText.checktime" width="110">
					<template scope="scope">{{ scope.row.data_create_time | moment('YYYY-MM-DD HH:mm:ss') }} </template>
				</el-table-column>

				<el-table-column :label="attrText.action" width="70">
					<template scope="scope">
						<el-button type="text" v-if="scope.row.tasks_status !== 'working'" @click.stop="view(scope.row)"><translate>View</translate></el-button>
						<el-button type="text" v-if="scope.row.tasks_status === 'working'" loading></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination" v-if="pageList.totalPage > 1">
				<el-pagination layout="prev, pager, next" :page-count="pageList.totalPage" :page-size="10" :current-page.sync="pageList.currentPage" @current-change="changePage"></el-pagination>
			</div>
		</div>
	</right-panel>
</template>

<script>
import { Utils, baseUrl } from '../../../config'
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import Utility from '../../../Utils'

export default {
	name: 'Check',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			showPassword: false,
			domain: '',
			teamName: '',
			creator_id: '',
			connects: '',
			connectInfo: {
				username: '',
				password: '',
				type: '',
			},
			pageList: {
				totalPage: 1,
				pageSize: 10,
				currentPage: 1,
			},
			reportTypeList: null,
			m: null,
			o: '',
			contact: { port: '', code: '', host: '' },
			canCreateStatus: false,
			currentAccountId: this.$store.getters.account.id,
			newTime: Math.ceil(new Date().getTime() / 1000),
			loading: false,
			tableLoading: false,
			btnLoading: false,
			// checkLoading: true,
			pollingList: [],
			pollingTimer: null,
			pollingStep: 0,
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	mounted() {},
	created() {
		console.log(this.$route.params.id, 'this.$route.params.id,')
	},
	methods: {
		getTranslateText() {
			return {
				reportname: this.$gettext('Report Name'),
				hostname: this.$gettext('Host Name'),
				checktime: this.$gettext('Check Time'),
				action: this.$gettext('Action'),
			}
		},
		onClose() {
			this.$emit('onClosePanel')
			this.$emit('reloadTunnelCode', [this.connects.project_resource_id])
			// && connects.agentVersion<'2.4.0'
			this.connects = null
		},
		// 切换页数
		changePage(page) {
			this.getCsosReport(this.connects.project_resource_id, page)
		},
		// 获取报告版本类型
		getReportVersionType(type) {
			console.log(type, 'type')
			const params = {
				type,
			}
			if (type.includes('MySQL')) {
				params.type = 'mysql'
			} else if (type.includes('SQLServer')) {
				params.type = 'mssql'
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_VERSION_BY_TYPE, params).then((res) => {
				if (res.success) {
					this.reportTypeList = res.content
				}
			})
		},
		// 发起诊断
		sendCheck() {
			this.btnLoading = true

			const params = {
				domain: this.domain,
				name: this.teamName,
				instance_name: this.connects.name,
				type: this.connects.type,
				version_id: this.connectInfo.type,
				resource_id: this.connects.project_resource_id,
				host: this.contact.host,
				databaseHost: this.connects.ip,
				port: this.contact.port,
				creator_id: this.creator_id,
				user: this.contact.code,
				databaseUser: this.connects.login_user[0],
				password: this.connectInfo.password,
				host_name: this.connects.db_name,
				project_id: this.$route.params.id,
				project_name: this.connects.project,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.CREATE_CSOS_REPORT, params).then(
				(res) => {
					this.btnLoading = false
					if (res.success) {
						this.$notify({
							message: res.message,
							type: 'success',
						})
						this.getCsosReport(this.connects.project_resource_id)
					} else {
						this.$notify({
							message: res.message,
							type: 'error',
						})
					}
				},
				() => {
					this.btnLoading = false
				}
			)
		},
		// 获取报告列表
		getCsosReport(id, pageIndex) {
			this.tableLoading = true

			const params = {
				page: pageIndex || 1,
				domain: this.domain,
				resource_id: id,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CSOS_REPORT, params).then(
				(res) => {
					console.log(res, 'csosReport')
					this.m = res.content.data
					this.pageList.totalPage = res.content.pages
					this.pageList.currentPage = res.content.page

					this.tableLoading = false

					this.pollingList = []
					this.m.forEach((i) => {
						if (i.tasks_status === 'working') {
							this.pollingList.push(i.id)
						}
					})
					if (this.pollingList.length) {
						clearTimeout(this.pollingTimer)
						this.polling(this.pollingList)
					}
				},
				() => {
					this.tableLoading = false
				}
			)
		},
		getConnectLog(id) {
			const params = {
				project_resource_id: id,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_TUNNEL_INFO, params).then((res) => {
				console.log(res, 'ooooooooo')
				this.o = res
				this.contact.code = res.code
				switch (res.os) {
					case 'mssql':
						this.contact.port = res.agent.mssql_port
						break
					case 'mysql':
						this.contact.port = res.agent.mysql_port
						break
					case 'linux':
						this.contact.port = res.agent.ssh_port
						break
					case 'windows':
						this.contact.port = res.agent.rdp_port
						break
					default:
						break
				}
				this.contact.host = res.agent.host
			})
			console.log(this.contact, 'contact')
		},
		// 查看报告
		view(row) {
			if (row.version.code == 'mysql_detection') {
				window.open(`${baseUrl.databaseReportUrl}/mysql/${row.id}`)
			} else if (row.version.code == 'mssql_detection') {
				window.open(`${baseUrl.databaseReportUrl}/sqlserver/${row.id}`)
			}
		},
		copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
		},
		polling(report_ids) {
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CSOS_REPORT_STATE, { report_ids: JSON.stringify(report_ids) }).then((res) => {
				console.log(res, 'res轮询')
				const data = res.content.data
				const reportIdArr = []
				for (let k in data) {
					if (data[k] === 'working') {
						reportIdArr.push(k)
					}
				}
				if (this.pollingStep != reportIdArr.length) {
					this.getCsosReport(this.connects.project_resource_id)
					this.pollingStep = reportIdArr.length
				}
				if (reportIdArr.length) {
					this.pollingTimer = setTimeout(() => {
						this.polling(reportIdArr)
					}, 3000)
				} else {
					this.getCsosReport(this.connects.project_resource_id)
					this.pollingList = []
				}
			})
		},
		hideStr(str) { 
			return Utility.Utils.hideStr(str)
		}
	},
	watch: {
		items: {
			handler: function (newVal) {
				// 获取团队信息
				this.$store.dispatch(STORE_CONST.TEAM.CURRENT).then((res) => {
					if (res) {
						console.log(res, 'res')
						this.domain = res.domain
						this.teamName = res.full_name
					}
					if (this.connects) {
						this.connects = ''
						setTimeout(() => {
							this.connects = this.items
							this.getCsosReport(this.connects.project_resource_id)
							this.getReportVersionType(this.connects.type)
							this.getConnectLog(this.connects.project_resource_id)
						}, 300)
					} else {
						this.connects = this.items
						this.getReportVersionType(this.connects.type)
						this.getCsosReport(this.connects.project_resource_id)
						this.getConnectLog(this.connects.project_resource_id)
					}
				})
				this.$store.dispatch(STORE_CONST.ACCOUNT.CURRENT).then((res) => {
					this.creator_id = res.name
				})
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
	destroyed() {
		clearTimeout(this.pollingTimer)
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../../assets/css/variable';
.check {
	.over-time {
		color: red;
	}
	.ip-space {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}
.check {
	font-size: 12px;
	.linux-username {
		.el-input__inner {
			font-size: 12px;
			width: 220px;
		}
	}
	.el-button {
		font-size: 12px;
	}
	a {
		color: $mainColor;
		&:hover {
			text-decoration: underline;
		}
	}
	.safeConnect {
		color: $danger-color;
		border-color: $danger-color;
	}
	.apply-safe {
		display: inline-block;
		color: $mainColor;
		border: 1px solid $mainColor;
		padding: 0 10px;
		height: 32px;
		line-height: 32px;
		&:hover {
			text-decoration: none;
		}
	}
	.b-b {
		line-height: 36px;
		padding-left: 10px;
		border-bottom: 1px solid $border-color;
	}
	.p-l-15 {
		padding-left: 15px;
	}
	.l-h-36 {
		line-height: 36px;
	}
	.b-t {
		line-height: 36px;
		padding-left: 10px;
		border-top: 1px solid $border-color;
	}
	.vertify-content {
		padding: 15px;
	}
	.el-row {
		padding-top: 10px;
		line-height: 32px;
	}
	.text-right {
		padding-right: 10px;
	}
	.win-image {
		display: block;
		margin: 0 auto;
	}
	.m-t {
		margin-top: 15px;
	}
	.w-full {
		width: 100%;
	}
	.tips {
		h4 {
			text-align: left !important;
			line-height: 20px;
		}
	}
	.material-icons {
		font-size: 18px;
		position: relative;
		top: 5px;
		margin-left: 5px;
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// check.vue?359adee7